import { PluginDocumentSettingPanel } from '@wordpress/editor';
import { registerPlugin } from '@wordpress/plugins';
import { useSelect, useDispatch } from '@wordpress/data';
import { Fragment } from '@wordpress/element';
import { checkConditionalLogic } from '../../utils/ConditionalLogicChecker';
import { fieldComponents, defaultValues } from '../../components/fieldComponents';

const SettingsPanel = () => {
    const meta = useSelect((select) =>
        select('core/editor').getEditedPostAttribute('meta') || {}
    );

    const { editPost } = useDispatch('core/editor');

    if (!window.VoxyFrameMeta || !Array.isArray(VoxyFrameMeta)) return null;

    return (
        <Fragment>
            {VoxyFrameMeta.map((group, groupIndex) => {
                if (!group.fields || !Array.isArray(group.fields)) return null;

                const panelKey =
                    group.id || group.slug || group.name || `group-${groupIndex}`;

                return (

                    <PluginDocumentSettingPanel
                        key={panelKey}
                        name={`voxyframe-group-${panelKey}`}
                        title={group.name}
                        className={`voxy-group-panel voxyframe-group-panel-${panelKey}`}
                    >
                        {group.fields.map((field, fieldIndex) => {
                            if (
                                field &&
                                !checkConditionalLogic(meta, field.conditional_logic)
                            ) {
                                return null;
                            }

                            const FieldComponent =
                                fieldComponents[field.type] || fieldComponents['text'];

                            const metaKey = field.field_key;

                            let value = meta?.[metaKey];

                            if (
                                (typeof value === 'undefined' || value === '') &&
                                defaultValues.hasOwnProperty(field.type)
                            ) {
                                value = defaultValues[field.type];
                            }

                            const onChange = (val) => {
                                editPost({
                                    meta: {
                                        ...meta,
                                        [metaKey]: val,
                                    },
                                });
                            };

                            const fieldKey =
                                metaKey ||
                                field.id ||
                                field.name ||
                                field.label ||
                                `field-${panelKey}-${fieldIndex}`;

                            return (
                                <FieldComponent
                                    key={fieldKey}
                                    field={field}
                                    value={value}
                                    onChange={onChange}
                                />
                            );
                        })}
                    </PluginDocumentSettingPanel>
                );
            })}
        </Fragment >
    );
};

registerPlugin('voxyframe-meta', {
    render: SettingsPanel,
    icon: null,
});
